export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14267.90bc6f39.jpg";